import {
  GenerateNetworkProbeVideoCallTokenMutation,
  GenerateNetworkProbeVideoCallTokenDocument,
} from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

export type GenerateNetworkProbeVideoCallTokenReturn =
  GenerateNetworkProbeVideoCallTokenMutation['generateNetworkProbeVideoCallToken']

export const generateNetworkProbeVideoCallToken =
  async (): Promise<GenerateNetworkProbeVideoCallTokenReturn> => {
    const res = await graphqlRequest(
      GenerateNetworkProbeVideoCallTokenDocument,
      {},
    )
    return res.generateNetworkProbeVideoCallToken
  }
